module.exports = __webpack_public_path__ + "img/zuki.0d014267.jpg";